<template>
  <div class="w-[60%] white-background bg-white dark:bg-slate-900">
    <div class="flex justify-space-between">
      <div class="card-style-text">{{ $t('PAYMENTS.RECENT_TRANSACTION') }}</div>
      <div class="flex gap-2">
        <div
          v-if="payments.payments.length > 0"
          class="view-all cursor-pointer"
          :class="{ 'import-clear': activeButton === 'download' }"
          @click="setActive('download')"  
        >
          <fluent-icon
            v-tooltip="'download List'"
            icon="arrow-download"
            size="20"
          />
        </div>
        <a
      v-if="payments.payments.length > 0"
      class="view-all cursor-pointer"
      :class="{ 'import-clear': activeButton === 'viewAll' }"
      :href="viewAllLink"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      {{ $t('PAYMENTS.VIEW_ALL') }}
    </a>
      </div>
    </div>
    <div>
      <div class="flex mt-4 table-list">
        <div class="row-style-text">{{ $t('PAYMENTS.AGENT') }}</div>
        <div class="row-style-text">{{ $t('PAYMENTS.STATUS') }}</div>
        <div class="row-style-text">{{ $t('PAYMENTS.DATE') }}</div>
        <div class="row-style-text">{{ $t('PAYMENTS.GST') }}</div>
        <div class="row-style-text">{{ $t('PAYMENTS.PAYMENT_TYPE') }}</div>
        <div class="row-style-text">{{ $t('PAYMENTS.AMOUNT') }}</div>
      </div>
      <!-- <div class="max-h-[15rem] overflow-y-scroll hide-scroll">
        <div
          class="flex p-2"
          v-for="(entry, index) in payments.payments"
          :key="index"
          :class="{ 'bg-slate-100 dark:bg-slate-700 flex  p-2': index % 2 != 0 }"
        >
          <div class="w-1/6 flex justify-center items-center">
            {{ entry.agent?.name ? truncate(entry.agent.name) : 'NA' }}
          </div>
          <div class="w-1/6 flex justify-center items-center ">{{ entry.name ? truncate(entry.name) : 'NA' }}</div>
          <div class="w-1/6 flex justify-center items-center ">
            {{ entry.created_at ? formatDate(entry.created_at) : 'NA' }}
          </div>
          <div class="w-1/6 flex justify-center items-center ">{{ entry.gst_no != null ? entry.gst_no : 'NA' }}</div>
          <div class="w-1/6 flex justify-center items-center ">
            {{ entry.payment_type != null ? entry.payment_type : 'NA' }}
          </div>
          <div class="w-1/6 flex justify-center items-center text-green-500">
            ₹{{ entry.amount != null ? entry.amount : 'NA' }}
          </div>
        </div>
        <div  v-if="payments.payments.length > 0" class="bg-slate-50 border-t-2 border-slate-400 flex justify-center items-center py-2 ">
          <a
      class="border border-slate-600 rounded-[7px]  px-4 py-2 bg-white cursor-pointer"
      :href="viewAllLink"
      target="_blank"
      rel="noopener noreferrer nofollow">
          See All
        </a>
      </div>
      </div> -->
      <div class="relative max-h-[15rem] flex flex-col">
  <div class="overflow-y-scroll flex-1 hide-scroll">
    <div
      class="flex p-2"
      v-for="(entry, index) in payments.payments"
      :key="index"
      :class="{ 'bg-slate-100 dark:bg-slate-700 flex p-2': index % 2 !== 0 }"
    >
      <div class="w-1/6 flex justify-center items-center">
        {{ entry.agent?.name ? truncate(entry.agent.name) : 'NA' }}
      </div>
      <div class="w-1/6 flex justify-center items-center">
        {{ entry.name ? truncate(entry.name) : 'NA' }}
      </div>
      <div class="w-1/6 flex justify-center items-center">
        {{ entry.created_at ? formatDate(entry.created_at) : 'NA' }}
      </div>
      <div class="w-1/6 flex justify-center items-center">
        {{ entry.gst_no != null ? entry.gst_no : 'NA' }}
      </div>
      <div class="w-1/6 flex justify-center items-center">
        {{ entry.payment_type != null ? entry.payment_type : 'NA' }}
      </div>
      <div class="w-1/6 flex justify-center items-center text-green-500">
        ₹{{ entry.amount != null ? entry.amount : 'NA' }}
      </div>
    </div>
    <div
    v-if="payments.payments.length > 14"
    class="relative -top-[40px] backdrop-blur-[2px] bg-white/20 dark:bg-slate-900/70  dark:border-slate-700 flex justify-center items-center py-2 z-[2]"
  >
    <a
      class="border border-slate-600 rounded-[7px] px-4 py-2 bg-white dark:bg-slate-800 cursor-pointer z-[3]"
      :href="viewAllLink"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      View All Transaction...
    </a>
  </div>
  </div>


</div>


    </div>
  </div>
</template>

<script>
export default {
  props: {
    payments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeButton: null, // 'download' or 'viewAll'
    };
  },
  computed: {
  viewAllLink() {
    const accountId = this.$route.params.accountId;
    return `/app/accounts/${accountId}/payment-dashboard/view-all?page=1`;
  },
},
  methods: {
    setActive(button) {
      this.activeButton = button;
      console.log("outside",this.activeButton);
      if(this.activeButton=='download')
      {
        console.log("inside")
        this.$emit('download_csv',true);
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '';

      // Convert seconds to milliseconds
      const date = new Date(timestamp * 1000);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2); // '25' from '2025'

      return `${day}/${month}/${year}`;
    },
    truncate(value, limit = 15) {
      if (typeof value !== 'string') return value;
      return value.length > limit ? value.slice(0, limit) + '...' : value;
    },    
  },
};
</script>

<style lang="scss" scoped>
.card-style-text {
  font-weight: 600;
  // color: #000;
}
.row-style-text {
  font-weight: 600;
  color: #000;
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.white-background {
  // background-color: #fff;
  border: 1px solid;
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  padding: 50px 25px;
}
.table-list {
  background: #ebebeb;
  padding: 6px 4px;
  border-radius: 5px;
}
.view-all {
  border: 1px solid #ebeef1;
  padding: 5px;
  border-radius: 5px;
  color: #035cff;
}
.import-clear {
  background-color: #40518a !important;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.light-grey {
  background-color: #f3f3f3;
}
.hide-scroll::-webkit-scrollbar{
  display: none;
}
.button_Class{
  border: 2px solid black;
    padding: 12px 26px;
    border-radius: 6px;
}
</style>